/** Публичный URL с учётом Vite `base` (`/admin/`, `/partner/` и т.д.). */
export function getPublicPath(path: string): string {
  return `${import.meta.env.BASE_URL}/${path}`.replace(/\/+/g, "/");
}
